module.exports = __webpack_public_path__ + "static/img/unsa.a1cd0ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/unsa.png
// module id = TGUd
// module chunks = 15